import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { IconButton, Snackbar } from '../../../components/atoms';
import { List, ListItem as PaymentItem } from '../../../components/atoms/List';
import { Add as AddIcon, Trash as TrashIcon } from '../../../components/icons';
import { getIsHTTPS } from '../../../components/partials/AddCreditCardDialog/tools/CreditCardFormUtils';
import {
  getPaymentTypeDetails,
  handleAddCard,
} from '../utils/PaymentMethodsUtils';

type Props = {
  handleDelete: (paymentAccountId: number) => void;
  payments: any[];
  translate: any;
};

const isHttps = getIsHTTPS();

const useStyles = makeStyles((theme: Theme) => ({
  trashButton: {
    backgroundColor: theme.palette.common.white,

    '& svg': {
      color: theme.palette.error.main,
    },

    '&:hover': {
      backgroundColor: theme.palette.error.main,

      '& svg': {
        color: theme.palette.common.white,
      },
    },
  },
}));

export const PaymentMethodList = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { handleDelete, translate } = props;
  const { payments } = props;

  const addNewCardItem: PaymentItem = {
    leftIcon: <AddIcon />,
    onClick: handleAddCard,
    primaryContent: translate('Add_card'),
  };

  const items: PaymentItem[] = payments.map((payment) => {
    const { text, icon, fdKey } = getPaymentTypeDetails(payment, translate);

    return {
      leftIcon: icon,
      primaryContent: text,
      rightIcon: (
        <IconButton
          aria-label={`${translate('Remove')} ${payment.Description}`}
          className={classes.trashButton}
          key={fdKey}
          onClick={() => {
            handleDelete(payment.PaymentAccountId);
          }}
        >
          <TrashIcon />
        </IconButton>
      ),
    };
  });

  if (isHttps) {
    items.push(addNewCardItem);
  }

  return (
    <>
      {!isHttps && (
        <Snackbar
          message={translate('Cards_cannot_added_SSL')}
          severity="warning"
        />
      )}

      <List items={items} />
    </>
  );
};
